'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiDatabase = function TiDatabase(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.6 14.7c-0.3-6.2-5.4-11.2-11.6-11.2s-11.3 5-11.6 11.2c0 0-0.1 0-0.1 0.1v10.4c0 6.4 5.3 11.7 11.7 11.7s11.7-5.3 11.7-11.7v-10.4c0-0.1-0.1-0.1-0.1-0.2z m-11.6 14.7c-3.7 0-6.9-2.2-8.3-5.4v-0.6c2.1 2.1 5 3.5 8.3 3.5s6.2-1.4 8.3-3.5v0.6c-1.4 3.2-4.6 5.4-8.3 5.4z m0-22.5c4.6 0 8.3 3.7 8.3 8.3s-3.7 8.3-8.3 8.3-8.3-3.7-8.3-8.3 3.7-8.3 8.3-8.3z m0 26.6c-3.8 0-7-2.5-8-6 2 2.2 4.8 3.5 8 3.5s6-1.3 8-3.5c-1 3.5-4.2 6-8 6z' })
        )
    );
};

exports.default = TiDatabase;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/database.js
// module id = 2027
// module chunks = 0